const dashboardTypes = {
  GET_DASHBOARDCARD_ANALYTICS: 'GET_DASHBOARDCARD_ANALYTICS',
  SET_DASHBOARDCARD_ANALYTICS: 'SET_DASHBOARDCARD_ANALYTICS',
  GET_PATIENT_VISIT: ' GET_PATIENT_VISIT',
  SET_PATIENT_VISIT: ' SET_PATIENT_VISIT'
};

export default dashboardTypes;
